import Phaser, {type Scene, type GameObjects} from "phaser"


type PatrolOptions = {
    obj: GameObjects.Sprite | GameObjects.Image;
    xLeft: number;
    xRight: number;
    xInitial: number;
    y: number;
    speed?: number;
}

type AlignGridConfig = {
    scene: Phaser.Scene;
    game: Phaser.Game;
    rows: number;
    cols: number;
    height?: number | string;
    width?: number | string;
}

export class AlignGrid {

    // Config object params
    scene: Scene | undefined;
    gameHeight: number = 0;
    gameWidth : number = 0;
    rowCount = 0;
    colCount = 0;
    // Computed properties
    cellHeight = 0;
    cellWidth = 0;
    // Graphical elements
    graphics: GameObjects.Graphics | undefined;
    numbers: GameObjects.Text[] = [];
    textGroup: GameObjects.Group | undefined;


    constructor(config: AlignGridConfig) {
        if (!config.scene) {
            console.log("missing scene!");
            return;
        }
        if (!config.width) {
            config.width = config.game.config.width;
        }
        if (!config.height) {
            config.height = config.game.config.height;
        }

        this.gameHeight = Number(config.height);
        this.gameWidth = Number(config.width);
        this.rowCount = config.rows;
        this.colCount = config.cols;
        this.scene = config.scene;

        // cell width is the scene width divided by the number of columns
        this.cellWidth = Number(this.gameWidth) / this.colCount;
        // cell height is the scene height divided the number of rows
        this.cellHeight = Number(this.gameHeight) / this.rowCount;
    }

    showGridNumbers(level: number) {

        // Remove all previous numbers
        if (this.textGroup) {
            this.textGroup.clear(true, true);
        }

        // Group all numbers for easy removal
        this.textGroup = this.scene!.add.group();

        // Loop over each row/column, display coords
        let n = 0 - ((level + 4) * this.colCount);
        for (let r = 0; r < this.rowCount; r++) {
            for (let c = 0; c < this.colCount; c++) {

                const rowNum = r - level - 4;
                const displayText = `(${c},${rowNum})`;

                let numText = this.scene!.add.text(0, 0, displayText, {
                    fontSize: 32,
                    color: 'black',
                });
                this.textGroup!.add(numText);
                numText.setOrigin(0.5, 0.5);
                this.placeAt(c, rowNum, numText);
                n++;
            }
        }
    }

    showGrid(level) {
        this.showGridNumbers(level);
        this.showGridLines(level);
    }

    showGridLines(level: number) {
        // Clear previous grid graphics if any
        if (this.graphics) {
            this.graphics.destroy();
        }

        this.graphics = this.scene!.add.graphics();
        this.graphics.lineStyle(4, 0xff0000, 1);
        this.graphics.beginPath();

        // Calculate Y offset based on the current level (how far the grid has scrolled)
        const yOffset = (level + 4) * this.cellHeight;

        // Draw vertical lines (borders)
        for (let i = 0; i <= this.gameWidth; i += this.cellWidth) {
            this.graphics.moveTo(i, -yOffset);
            this.graphics.lineTo(i, this.gameHeight - yOffset);
        }

        // Draw horizontal lines, but shift vertically according to the current level
        for (let i = -yOffset; i < this.gameHeight; i += this.cellHeight) {
            this.graphics.moveTo(0, i);
            this.graphics.lineTo(this.gameWidth, i);
        }

        // Finish drawing
        this.graphics.strokePath();
    }

    // placeAtIndex(index, obj) {
    //     var yy = Math.floor(index / this.colCount);
    //     var xx = index - (yy * this.colCount);
    //     this.placeAt(xx, yy, obj);
    // }


    patrol(opts: PatrolOptions) {

        // Get absolute left and right positions
        let xLeftPos = this.cellWidth * opts.xLeft + this.cellWidth / 2;
        let xRightPos = this.cellWidth * opts.xRight + this.cellWidth / 2;

        // Set initial position
        this.placeAt(opts.xInitial, opts.y, opts.obj);

        // Set initial direction. When true, direction is right. False when going left
        opts.obj.flipX = true;

        // Calculate the initial travel time
        // const distanceToX2 = Math.abs(x3 - x2);

        const initialDuration = 2000 - ((opts.xInitial+1) * 400);

        console.log(`Initial X: ${opts.xInitial}\n Initial Duration: ${initialDuration}`);
        const squaresToTravel = 5 - opts.xInitial;
        // 0 1800
        // 1
        // 2
        // 3
        // 4 (not possible)

        // Initial tween: Move from x3 to x2
        this.scene.tweens.add({
            targets: opts.obj,
            x: xRightPos,
            duration: initialDuration,
            ease: 'Linear',
            onComplete: () => {
                // Start the looping tween after reaching x2
                // startLoopingTween(object, x1, x2, speed);
                opts.obj.flipX = !opts.obj.flipX;
                this.scene.tweens.add({
                    targets: opts.obj,
                    x: xLeftPos,          // Target x position
                    duration: 2000,      // Duration of the animation in milliseconds
                    ease: 'Linear',      // Easing function for smooth movement
                    yoyo: true,          // Move back to the start position
                    repeat: -1,          // Repeat infinitely
                    onYoyo: function () {
                        opts.obj.flipX = !opts.obj.flipX;
                    },
                    onRepeat: function () {
                        opts.obj.flipX = !opts.obj.flipX;
                    }
                });
            },
        });


        // Move the obstacle back and forth along the x-axis
        // this.scene.tweens.add({
        //     targets: opts.obj,
        //     x: xEndPos,           // Target x position
        //     duration: 1800,      // Duration of the animation in milliseconds
        //     ease: 'Linear',      // Easing function for smooth movement
        //     yoyo: true,          // Move back to the start position
        //     repeat: -1,          // Repeat infinitely
        //     onYoyo: function () {
        //         debugger;
        //         opts.obj.flipX = false;
        //     },
        //     onRepeat: function () {
        //         debugger;
        //         opts.obj.flipX = true;
        //     }
        // });

    }

    placeAt(xx, yy, obj, animate = false) {
        //calculate the center of the cell
        //by adding half of the height and width
        //to the x and y of the coordinates
        var x2 = this.cellWidth * xx + this.cellWidth / 2;
        var y2 = this.cellHeight * yy + this.cellHeight / 2;


        if (animate) {
            this.scene.tweens.add({
                targets: obj,      // The object to animate
                x: x2,                  // The target x-coordinate
                y: y2,                  // The target y-coordinate
                duration: 460,          // Animation duration in milliseconds (1000 ms = 1 second)
                ease: 'Power2',          // Easing function for smooth animation
                onComplete: function () {
                    console.log('Character has reached the destination!');
                }
            });
        } else {
            obj.x = x2;
            obj.y = y2;
        }

    }


}